export default "__VITE_ASSET__DdSSYTmh__"